import React from 'react';
import { CardContent, CardHeader, CardTitle } from './Card';
import Button from './Button';
import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title = 'Confirm', message, confirmText = 'OK', cancelText = '' }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onEnter={handleConfirm}
      className="w-full max-w-md mx-4"
    >
      <CardHeader className="pr-10">
        <CardTitle className="flex items-center text-gray-900">
          <AlertTriangle className="h-5 w-5 mr-2 text-yellow-600" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4 whitespace-pre-line break-words [overflow-wrap:anywhere]">{message}</p>
        <div className="flex justify-end gap-2">
          {cancelText ? (
            <button
              type="button"
              onClick={onClose}
              className="h-10 rounded-md px-4 text-sm text-zinc-600 hover:bg-[#E8EEF5]"
            >
              {cancelText}
            </button>
          ) : null}
          <Button
            variant="outline"
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </CardContent>
    </Modal>
  );
};

export default ConfirmDialog;
